const items = state => state.items.data
const obj = state => state.obj.data
const error = state => state.error
const isLoading = state => state.isLoading
const item = state => state.item.data
const bids = state => state.bids.data
const isLoadingBidPrice = state => state.isLoadingBidPrice
const isErrorLoadingBidPrice = state => state.isErrorLoadingBidPrice
const bidPrice = state => state.bidPrice.data
const errorBid = state => state.errorBid
const isLoadingBid = state => state.isLoadingBid
const itemCancel = state => state.itemCancel
const isLoadingCancel = state => state.isLoadingCancel
const errorCancel = state => state.errorCancel

const OnGoing = state => state.OnGoing.data
const isLoadingOnGoing = state => state.isLoadingOnGoing
const isErrorOnGoing = state => state.isErrorOnGoing

const details = state => state.details.data
const isLoadingDetails = state => state.isLoadingDetails
const isErrorDetails = state => state.isErrorDetails

const isLoadingExtend = state => state.isLoadingExtend
const errorExtend = state => state.errorExtend
const itemExtend = state => state.itemExtend

const itemBA = state => state.itemBA.data
const errorBA = state => state.errorBA
const isLoadingBA = state => state.isLoadingBA

const acceptBA = state => state.acceptBA
const errorAcceptBA = state => state.errorAcceptBA
const isLoadingAcceptBA = state => state.isLoadingAcceptBA

const downloadBA = state => state.downloadBA
const errorDownloadBA = state => state.errorDownloadBA
const isLoadingDownloadBA = state => state.isLoadingDownloadBA

const isShowAgreement = state => state.isShowAgreement.data
const isLoadingAgreement = state => state.isLoadingAgreement
const isErrDownloadAgreement = state => state.isErrDownloadAgreement

const contractFilter = state => state.contractFilter.data
const errorContractFilter = state => state.errorContractFilter
const isLoadingContractFilter = state => state.isLoadingContractFilter

export default {
  isLoading,
  items,
  obj,
  error,
  item,
  bids,
  isLoadingBidPrice,
  isErrorLoadingBidPrice,
  bidPrice,
  errorBid,
  isLoadingBid,
  itemCancel,
  isLoadingCancel,
  errorCancel,
  OnGoing,
  details,
  isLoadingOnGoing,
  isErrorOnGoing,
  isLoadingDetails,
  isErrorDetails,
  isLoadingExtend,
  errorExtend,
  itemExtend,
  itemBA,
  errorBA,
  isLoadingBA,
  acceptBA,
  errorAcceptBA,
  isLoadingAcceptBA,
  downloadBA,
  errorDownloadBA,
  isLoadingDownloadBA,

  isShowAgreement,
  isLoadingAgreement,
  isErrDownloadAgreement,

  contractFilter,
  errorContractFilter,
  isLoadingContractFilter
}



// WEBPACK FOOTER //
// ./src/store/modules/contract/getters.js